import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '@shared/modules/toast/services/toast.service';
import { getErrorTranslationKey } from '@shared/utils/error-keys.util';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService {
  constructor(private toast: ToastService) {}

  handleError(errorResponse: HttpErrorResponse): void {
    if (errorResponse.status === 403) {
      this.toast.showError('validation_errors.permission_denied');
      return;
    }

    const errors = errorResponse?.error?.errors || errorResponse?.error?.error;

    if (!errors) {
      return;
    }

    const firstError = getErrorTranslationKey(errors, null);
    if (!firstError) {
      return;
    }

    this.toast.showError(firstError);
  }
}
